import { defineMessages } from 'utils/intl';

export default defineMessages({
  paramsCopied: 'Skopiowano parametry URL',
  targetUrlCopied: 'Skopiowano adres przekierowania',
});
